/** Answer guidance helpers for Storybook Mode. */

export function countWords(text) {
  if (!text || !String(text).trim()) return 0;
  return String(text).trim().split(/\s+/).filter(Boolean).length;
}

export function estimateReadingMinutes(wordCount) {
  if (!wordCount) return 0;
  return Math.max(1, Math.round(wordCount / 180));
}

export function answerQualityMessage(wordCount, completed) {
  if (completed) return 'Marked complete';
  if (wordCount >= 150) return 'This answer is ready for your storybook.';
  if (wordCount >= 40) return 'Good progress — a few more details when you are ready.';
  if (wordCount > 0) return 'Good start — just begin; you can refine later.';
  return null;
}

export const DEFAULT_GUIDANCE = {
  suggestedWords: '150–500 words',
  suggestedTime: '5–10 minutes',
  voiceGuide: 'Two minutes of voice is enough',
  tip: 'Start with one scene. You can come back later — you do not need to write perfectly.',
};

export const DEEP_PROMPT_GUIDANCE = {
  short: 'Short answer: 2–3 sentences',
  full: 'Full memory: 300–700 words',
  chapter: 'Chapter-ready: spread across several prompts',
};

export function isDeepPrompt(promptText = '') {
  const t = promptText.toLowerCase();
  return (
    t.includes('describe') ||
    t.includes('tell the story') ||
    t.includes('walk us through') ||
    t.includes('in detail') ||
    t.length > 120
  );
}

export function transcriptionStatusLabel(status) {
  switch (status) {
    case 'queued':
    case 'pending':
      return 'Queued';
    case 'processing':
      return 'Transcribing';
    case 'completed':
      return 'Transcript completed';
    case 'failed':
      return 'Transcription failed';
    default:
      return null;
  }
}
